import React from 'react';
import { useParams } from 'react-router-dom';
import { DVITemplateBuilder } from '../../components/DVI';

const DVITemplateBuilderPage: React.FC = () => {
  const { id } = useParams();
  const templateId = id === 'new' || id == null ? undefined : Number(id);
  return <DVITemplateBuilder templateId={templateId} />;
};

export default DVITemplateBuilderPage;
